/** Κεντρική μορφή ημερομηνιών: dd/mm/yyyy (και dd/mm/yyyy HH:mm για ώρα). */

export function pad2(value: number): string {
  return value.toString().padStart(2, '0')
}

/** dd/mm/yyyy */
export function formatDateDisplay(date: Date): string {
  return [pad2(date.getDate()), pad2(date.getMonth() + 1), date.getFullYear()].join(
    '/',
  )
}

/** yyyy-mm-dd — εσωτερική τιμή DateInput */
export function formatDateInputValue(date: Date): string {
  return [date.getFullYear(), pad2(date.getMonth() + 1), pad2(date.getDate())].join(
    '-',
  )
}

/** Από yyyy-mm-dd (ή ISO με prefix) σε Date (τοπική ημέρα). */
export function parseDateInputValue(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim())
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(year, month - 1, day)

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null
  }

  return date
}

export function formatDateEl(
  value: string | Date | null | undefined,
  fallback = '—',
): string {
  if (value == null || value === '') return fallback
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return fallback
  return formatDateDisplay(date)
}

/** dd/mm/yyyy, HH:mm (24ωρο) */
export function formatDateTimeEl(
  value: string | Date | null | undefined,
  fallback = '—',
): string {
  if (value == null || value === '') return fallback
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return fallback
  return `${formatDateDisplay(date)}, ${pad2(date.getHours())}:${pad2(date.getMinutes())}`
}

/** ISO → yyyy-mm-dd για DateInput */
export function isoToDateInputValue(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return formatDateInputValue(date)
}

/** yyyy-mm-dd από DateInput → ISO λήξης 23:59:59 (τοπική ώρα). */
export function dateInputToEndOfDayIso(dateOnly: string): string {
  const date = parseDateInputValue(dateOnly)
  if (!date) {
    throw new Error('Μη έγκυρη ημερομηνία.')
  }
  date.setHours(23, 59, 59, 999)
  return date.toISOString()
}
